import { AnyAction, Dispatch } from "redux";

import * as Sentry from "@sentry/browser";

import { makeRequest } from "../util";
import {
  AccountMetadata,
  SET_ACCOUNT_METADATA,
  SET_CURRENT_ENVIRONMENT,
  SET_ACCOUNT_METADATA_UPDATING,
} from "../reducers/environments";
import { ThunkAction, ThunkDispatch } from "redux-thunk";

export const fetchAccountMetadata = () => {
  return async (dispatch: Dispatch) => {
    return makeRequest<AccountMetadata>("account_metadata", {})
      .then((response) => {
        dispatch({ type: SET_ACCOUNT_METADATA, payload: response.data });
      })
      .catch((err) => {
        Sentry.captureException(err);
      });
  };
};

export const setCurrentEnvironment = (envID: string) => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: SET_CURRENT_ENVIRONMENT, payload: envID });
  };
};

export const updatePhiAllowlist = (allowListType: string, newAllowListedProps: string[]): ThunkAction<Promise<void>, any, unknown, AnyAction> => {
  return async (dispatch) => {
    dispatch({ type: SET_ACCOUNT_METADATA_UPDATING });

    const newValidatedProps = newAllowListedProps.filter(prop => prop.length != 0);

    await makeRequest("update_phi_allowlist", { sensitivity_type: allowListType, allowlisted_properties: newValidatedProps });

    // Because this state is in a few places in the 'environments' store ('accountMetadata.projects' and 'currentEnvironment'), just refresh
    // the account metadata.
    await dispatch(fetchAccountMetadata());
  };
};
